"use client";

import styles from "./ViewHeader.module.scss";

export const ViewHeader = ({
  heading,
  description,
}: {
  heading: string;
  description: string;
}) => {
  return (
    <div className={styles["comp"]}>
      <div className={styles["comp__heading"]}>{heading}</div>
      <div
        className={styles["comp__description"]}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
};
